import * as React from 'react';
import { ImageContainerProps } from './image-container-type';
import { LoadableImage } from '../loadable-image';

import styles from './image-container-component.module.css';

export const ImageContainer: React.FC<ImageContainerProps & { children?: React.ReactNode }> = ({
    style,
    className,
    placeholderClassName,
    placeholderStyle,
    children,
    color,
    small,
    medium,
    large,
    onloaded,
}: ImageContainerProps & { children?: React.ReactNode }) => {
    const [imgLoaded, setiImgLoaded] = React.useState(false);
    const internalOnLoaded = React.useCallback(() => {
        setiImgLoaded(true);
        if (onloaded) {
            onloaded();
        }
    }, [onloaded]);

    return (
        <>
            {large ? (
                <picture style={style}>
                    {small && (
                        <source
                            media="(max-width: 767px)"
                            srcSet={small.url.split('?')[0] + (small.maxWidth ? `?width=${small.maxWidth}` : '')}
                            style={style}
                        />
                    )}
                    {medium && (
                        <source
                            media="(max-width: 1024px)"
                            srcSet={medium.url.split('?')[0] + (medium.maxWidth ? `?width=${medium.maxWidth}` : '')}
                            style={style}
                        />
                    )}
                    <LoadableImage
                        className={styles.blockImg}
                        placeholderClassName={placeholderClassName}
                        placeholderStyle={placeholderStyle}
                        src={large.url.split('?')[0] + (large.maxWidth ? `?width=${large.maxWidth}` : '')}
                        alt=""
                        style={style}
                        onLoad={internalOnLoaded}
                    />
                </picture>
            ) : (
                <div className={styles.backgroundColor} style={{ backgroundColor: color }} />
            )}
            {children && imgLoaded && (
                <div style={style} className={`${className} ${styles['contenu-container']} loaded-animation`}>
                    {children}
                </div>
            )}
        </>
    );
};
